import { render } from "./LanguageChange.vue?vue&type=template&id=1125c1af&scoped=true"
import script from "./LanguageChange.vue?vue&type=script&lang=js"
export * from "./LanguageChange.vue?vue&type=script&lang=js"

import "./LanguageChange.vue?vue&type=style&index=0&id=1125c1af&lang=css"
import "./LanguageChange.vue?vue&type=style&index=1&id=1125c1af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1125c1af"],['__file',"src/Components/LanguageChange/LanguageChange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1125c1af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1125c1af', __exports__)) {
    api.reload('1125c1af', __exports__)
  }
  
  module.hot.accept("./LanguageChange.vue?vue&type=template&id=1125c1af&scoped=true", () => {
    api.rerender('1125c1af', render)
  })

}


export default __exports__